import { useCallback } from "react";
import { RejoinModalViewModel } from "../../../session/rejoin/types";
import {
  REJOIN_ERROR_TOAST_TAGS,
  RejoinError,
  useBaseRejoinModalViewModel,
} from "../../../session/rejoin/useBaseRejoinModalViewModel";
import { toast } from "../../../toasts";
import { secondsToMilliseconds } from "date-fns";
import { wait } from "../../../utils";

function errorToToastMessage(error: RejoinError) {
  const errorKind = "kind" in error ? error.kind : "unexpected";
  switch (errorKind) {
    case "empty-room":
      return "Your provider may have left the session. Rejoining waiting room.";
    default:
      return "An unexpected error occurred. Rejoining waiting room.";
  }
}

function showErrorToast(error: RejoinError) {
  toast.error(errorToToastMessage(error), {
    purpose: "system",
    timeout: Infinity,
    tags: REJOIN_ERROR_TOAST_TAGS,
  });
}

function reloadPage() {
  location.reload();
}

export function useVisitorRejoinModalViewModel(): RejoinModalViewModel {
  const { isLoading, isOpen, rejoin, closeModal } =
    useBaseRejoinModalViewModel();

  const handleRejoin = useCallback(() => {
    rejoin({
      onTerminalFailure: async (error) => {
        showErrorToast(error);
        closeModal();
        // Allow some time to read toast before reloading the page
        return wait(secondsToMilliseconds(3)).finally(reloadPage);
      },
    });
  }, [closeModal, rejoin]);

  return {
    isOpen,
    isLoading,
    onJoin: handleRejoin,
  };
}
